import React from "react";
import HtmlHeadInjector from "../components/HtmlHeadInjector";
import LegacyLandingSection from "../components/LegacyLandingSection";
import useCheckoutLink from "../components/useCheckoutLink";

/**
 * Página React pura:
 * - Injeta os CSS/JS originais
 * - Renderiza o HTML do seu <body> (LegacyLandingSection)
 * - Liga automaticamente os botões de compra ao seu checkout
 */
export default function LandingFromPackagePure() {
  useCheckoutLink({ fallbackSku: "LC-CP-VOL1", checkoutPath: "/checkout" });

  return (
    <main>
      <HtmlHeadInjector title="Landing" />
      <LegacyLandingSection />
    </main>
  );
}
